type IconProps = {
  fillColor: string;
};

export const LargeCheckbox = ({ fillColor }: IconProps) => (
  <svg width="74" height="74" viewBox="0 0 74 74" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M53.8307 20.793L29.6673 44.9563L16.504 31.8297L11.334 36.9997L29.6673 55.333L59.0007 25.9997L53.8307 20.793ZM37.0007 0.333008C16.7607 0.333008 0.333984 16.7597 0.333984 36.9997C0.333984 57.2397 16.7607 73.6663 37.0007 73.6663C57.2407 73.6663 73.6673 57.2397 73.6673 36.9997C73.6673 16.7597 57.2407 0.333008 37.0007 0.333008ZM37.0007 66.333C20.794 66.333 7.66732 53.2063 7.66732 36.9997C7.66732 20.793 20.794 7.66634 37.0007 7.66634C53.2073 7.66634 66.334 20.793 66.334 36.9997C66.334 53.2063 53.2073 66.333 37.0007 66.333Z"
      fill={fillColor}
    />
  </svg>
);

export const LargeEnvelope = ({ fillColor }: IconProps) => (
  <svg width="70" height="55" viewBox="0 0 70 55" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.952 0C3.584 0 0 3.416 0 7.616V47.376C0 51.576 3.584 54.992 7.952 54.992H62.048C66.416 54.992 70 51.576 70 47.376V7.616C70 3.416 66.416 0 62.048 0H7.952ZM7.952 3.08H62.048C64.736 3.08 66.808 5.096 66.808 7.616V7.784L35 38.304L3.192 7.784V7.616C3.192 5.096 5.264 3.08 7.952 3.08ZM3.192 12.096L19.6 27.832L3.192 43.568V12.096ZM66.808 12.096V43.008L50.68 27.552L66.808 12.096ZM48.44 29.736L66.808 47.376C66.808 49.896 64.736 51.912 62.048 51.912H7.952C5.488 51.912 3.472 50.176 3.192 47.88L21.84 29.96L33.88 41.552C34.496 42.168 35.504 42.168 36.12 41.552L48.44 29.736Z"
      fill={fillColor}
    />
  </svg>
);
